module.exports = __webpack_public_path__ + "s/img/Power_M_3.4c3f7e35.jpg";